<template>
	<div class="agreement">
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto py-[30px] box-border">
			<div class="text-[#101010] text-[24px] mb-[10px] font-bold text-center">{{title}}</div>

			<div class="text-[16px]" v-html="content">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mark: '',
				content: '',
				title: '',
				langInfo:'',
			}
		},
		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			
			
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			else{
				if (this.$route.query.mark == 'UserAgreement') {
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.reg_agree
				} else if (this.$route.query.mark == 'PrivacyAgreement') {
					document.title = this.langInfo.pc_name+'-'+this.langInfo.reg_hide
				}else if (this.$route.query.mark == 'ContactUs') {
					document.title = this.langInfo.pc_name+'-'+this.langInfo['Contact us']
				}else if (this.$route.query.mark == 'AboutUs') {
					document.title = this.langInfo.pc_name+'-'+this.langInfo['AboutUs']
				}
			}
			
			
			this.mark = this.$route.query.mark

			this.agreement()
			this.getconfig()
		},
		methods: {
			
			getconfig() {
				this.$api.config({}).then((res) => {
					console.log(res);
			
					var link = document.querySelector("link[rel~='icon']");
					if (!link) {
						link = document.createElement('link');
						link.rel = 'icon';
						document.head.appendChild(link);
					}
					link.href = res.data.url_logo
				}).catch((error) => {
					if (error.code == 450) {
						localStorage.removeItem('userInfo')
						localStorage.removeItem('token')
						this.$router.go(0)
					}
				})
			},
			
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj={}
					res.data.forEach((item,index)=>{
						obj[item.key]=item.value
					})
					this.langInfo=obj
					if (this.$route.query.mark == 'UserAgreement') {
						document.title =this.langInfo.pc_name+'-'+ this.langInfo.reg_agree
					} else if (this.$route.query.mark == 'PrivacyAgreement') {
						document.title = this.langInfo.pc_name+'-'+this.langInfo.reg_hide
					}else if (this.$route.query.mark == 'ContactUs') {
						document.title = this.langInfo.pc_name+'-'+this.langInfo['Contact us']
					}else if (this.$route.query.mark == 'AboutUs') {
						document.title = this.langInfo.pc_name+'-'+this.langInfo['AboutUs']
					}
					
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			agreement() {
				this.$api.agreement({
					mark: this.mark
				}).then((res) => {
					console.log(res.data.content);
					this.content = res.data.content
					this.title = res.data.title
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}
		}
	}
</script>

<style  scoped>
	/deep/p img{
		width: 100% !important;
	}
</style>